<style>
.input-container {
  position: relative;
  display: inline-block;
}
#priceInput {
  padding-right: 50px;
}
#currencySelect {
  position: absolute;
  right: 0;
  top: 0;
  border: none;
  height: 100%;
  width: 50px;
  background: white;
}
#currencySelect {
  appearance: none;
  padding-right: 15px;
  padding-left: 2px;
  border: 1px solid #d8d6de;
  border-radius: 4px;
}
</style>

<template>
  <div>
    <!-- Form Modal -->
    <b-modal id="modal-season-form" ref="myModal" centered no-close-on-backdrop no-close-on-esc @ok="submit" size="lg">
      <template #modal-header="{ close }">
        <h5>Register Input Price</h5>
        <feather-icon class="ml-4 pr-0 cursor-pointer" icon="XIcon" size="16" @click="close()" />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button size="md" variant="primary" @click="ok()" :disabled="saving">
          <b-spinner small class="mr-1" label="Small Spinner" v-if="saving" />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button size="md" @click="cancel()" variant="outline-secondary">Cancel</b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{}">
        <validation-observer ref="dataForm" #default="{ invalid }">
          <b-form ref="form" @submit.stop.prevent="handleCreate">
            <b-row>
              <b-col cols="6">
                <b-form-group labe-for="Input" label="Input" style="cursor: pointer">
                  <validation-provider #default="{ errors }" name="input_id" rules="">
                    <b-form-select id="input_id" name="input_id" size="md" v-model="input.input_id">
                      <b-form-select-option :value="null">Select...</b-form-select-option>
                      <b-form-select-option v-for="input in inputs" :key="input.id" :value="input.id">
                        {{ input.name }}
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger" v-if="serverErrors && serverErrors.input_id">{{ serverErrors.input_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group labe-for="Location" label="Location" style="cursor: pointer">
                  <validation-provider #default="{ errors }" name="location_id" rules="">
                    <b-form-select id="location_id" name="location_id" size="md" v-model="input.location_id">
                      <b-form-select-option :value="null">Select...</b-form-select-option>
                      <b-form-select-option v-for="location in locations" :key="location.id" :value="location.id">
                        {{ location.name }}
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger" v-if="serverErrors && serverErrors.location_id">{{ serverErrors.location_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <br />

            <b-row>
              <b-col cols="6">
                <b-form-group labe-for="Currency" label="Currency" style="cursor: pointer">
                  <validation-provider #default="{ errors }" name="currency_id" rules="">
                    <b-form-select id="currency_id" name="currency_id" size="md" v-model="input.currency_id">
                      <b-form-select-option :value="null">Select...</b-form-select-option>
                      <b-form-select-option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                        {{ currency.abbreviation }}
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger" v-if="serverErrors && serverErrors.currency_id">{{ serverErrors.currency_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group labe-for="Price" label="Price">
                  <validation-provider #default="{ errors }" name="price" rules="">
                    <div class="input-container">
                      <b-form-input id="price" name="price" size="md" v-model="input.price" />
                    </div>
                    <br />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger" v-if="serverErrors && serverErrors.price">{{ serverErrors.price[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col cols="6" md="2">
            <label>Season</label>
            <b-form-select size="sm" v-model="input.season_id" @change="changeSeason()" disabled>
              <b-form-select-option v-for="season in seasons" :key="season.id" :value="season.id" v-if="season.isRunning"> {{ season.startYear }}/{{ season.endYear }} </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Show</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50 select-size-sm" />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." size="sm" />
              <b-button variant="primary" size="sm" @click="invokeCreateForm()">
                <span class="text-nowrap">Register Inputs</span>
              </b-button>
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table :busy="isBusy" striped hover small ref="records" class="position-relative" :items="fetch" responsive :fields="columns" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No records found" :sort-desc.sync="isSortDirDesc">
        <template #cell(units)="data"> {{ data.item.units[data.item.units.length - 1].name }} ({{ data.item.units[data.item.units.length - 1].abbreviation }}) </template>
        <template #cell(packaging)="data">
          <span v-if="data.item.packaging">{{ data.item.packaging.amount }} {{ data.item.packaging.unit }} </span>
        </template>
        <template #cell(prices)="data">
          <span v-if="data.item.prices.length > 0">
            {{ formatPrice(data.item.prices[data.item.prices.length - 1].value) }}
            {{ data.item.prices[data.item.prices.length - 1].currency.abbreviation }}
          </span>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="remove(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { required } from "@validations";
import store from "@/store";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination, BForm, BFormGroup, BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem, BFormDatepicker, BFormCheckbox, BSpinner, BBadge } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import inputPriceStoreModule from "@/views/cromis/input_prices/inputPriceStoreModule";
import useInputPricesList from "@/views/cromis/input_prices/useInputPricesList";

export default {
  props: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BPagination,
    BForm,
    BFormGroup,
    BButton,
    BFormSelect,
    BFormSelectOption,
    BFormInput,
    vSelect,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    BFormCheckbox,
    BSpinner,
    BBadge,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {},
  setup(props, context) {
    const dataForm = ref(null);
    const myModal = ref(null);
    const saving = ref(false);
    const serverErrors = ref(null);
    const seasons = ref([]);
    const units = ref([]);
    const inputs = ref([]);
    const locations = ref([]);
    const currencies = ref([]);
    const selectedUnit = ref({
      id: null,
      name: null,
      abbreviation: null,
      needDescription: false,
    });

    const input = ref({
      input_id: null,
      unit_id: null,
      location_id: null,
      currency_id: null,
      season_id: null,
    });

    const CROMIS_STORE_MODULE_NAME = "cromis-input";

    // Register module
    if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) {
      store.registerModule(CROMIS_STORE_MODULE_NAME, inputPriceStoreModule);
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CROMIS_STORE_MODULE_NAME)) {
        store.unregisterModule(CROMIS_STORE_MODULE_NAME);
      }
    });

    onMounted(async () => {
      await store
        .dispatch("cromis-input/inputs", { isRunning: 1 })
        .then((response) => {
          inputs.value = response.data.inputs;
        })
        .catch((error) => {
          console.log("got error", error);
        });

      await store
        .dispatch("cromis-input/seasons", { isRunning: 1 })
        .then((response) => {
          seasons.value = response.data.seasons;
          if (seasons.value.length > 0) {
            input.value.season_id = seasons.value[0].id;
            changeSeason(input.value.season_id);
          }
        })
        .catch((error) => {
          console.log("got error", error);
        });

      await store
        .dispatch("cromis-input/locations")
        .then((response) => {
          locations.value = response.data.locations;
        })
        .catch((error) => {
          console.log("got error", error);
        });

      await store
        .dispatch("cromis-input/currencies")
        .then((response) => {
          console.log(response.data);
          currencies.value = response.data.currencies;
        })
        .catch((error) => {
          console.log("got error", error);
        });
    });

    const changeSeason = async () => {
      season_id.value = input.value.season_id;
    };

    const {
      fetch,
      columns,
      perPage,
      currentPage,
      totalRecords,
      from,
      to,
      meta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      records,
      refetch,
      isBusy,
      // Filers
      season_id,
      // Resolvers
      resolveStatusVariant,
    } = useInputPricesList();

    const formatPrice = (value) => {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // Form Methods
    const invokeUpdateForm = (item) => {
      serverErrors.value = null;
      input.value = {
        id: item.id,
        season_id: input.value.season_id,
        name: item.name,
        recommended: item.recommended,
        price: item.prices[item.prices.length - 1].value,
        unit_id: item.units[0],
        per_id: item.per_id,
        currency_id: item.currency.id,
        descriptionAmount: item.packaging.amount,
        description_id: item.packaging.description_id,
      };
      myModal.value.show();
    };

    const invokeCreateForm = () => {
      serverErrors.value = null;

      input.value = {
        id: null,
        season_id: input.value.season_id,
        name: null,
        recommended: null,
        price: null,
        unit_id: null,
        per_id: null,
        currency_id: null,
        descriptionAmount: null,
        description_id: null,
      };

      myModal.value.show();
    };

    const isFormValid = async () => {
      let isValid = false;
      await dataForm.value.validate().then((success) => {
        isValid = success;
      });
      return isValid;
    };

    const submit = (bvModalEvt) => {
      bvModalEvt.preventDefault();
      serverErrors.value = null;
      // Handle form submit
      if (input.value.id === null || input.value.id === 0) {
        handleCreate();
      } else {
        handleUpdate(input.value);
      }
    };

    const changeUnit = async (event) => {
      input.value.unit_id = event;
      selectedUnit.value = event;
      // console.log(event)
    };

    const handleCreate = async () => {
      saving.value = true;
      input.value.unit_id = selectedUnit.value.id;
      const valid = await isFormValid();
      if (!valid) {
        saving.value = false;
        return;
      }
      await store
        .dispatch("cromis-input/create", input.value)
        .then((response) => {
          refetch();
          saving.value = false;
          myModal.value.hide();
          context.root.$swal({
            icon: "success",
            text: `Grade ${response.data.name} registered successfully!`,
            showConfirmButton: true,
            timer: 3000,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          saving.value = false;
          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors;
          } else {
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            });
          }
        });
    };

    const handleUpdate = async (item) => {
      saving.value = true;
      const valid = await isFormValid();

      if (!valid) {
        saving.value = false;
        return;
      }

      await store
        .dispatch("cromis-input/update", { id: item.id, data: item })
        .then((response) => {
          refetch();
          saving.value = false;
          myModal.value.hide();
          context.root.$swal({
            icon: "success",
            text: `Changes to input # ${response.data.name} has been saved successfully!`,
            showConfirmButton: true,
            timer: 3000,
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          saving.value = false;
          if (error.response.status === 422) {
            serverErrors.value = error.response.data.errors;
          } else {
            context.root.$swal({
              icon: "error",
              title: "Server Error",
              text: "Something went wrong. See tech support",
              showConfirmButton: true,
              customClass: {
                confirmButton: "btn btn-danger",
              },
              buttonsStyling: false,
            });
          }
        });
    };

    const remove = async (id) => {
      await store
        .dispatch("cromis-input/remove", id)
        .then((response) => {
          refetch();
        })
        .catch((error) => {
          context.root.$swal({
            icon: "error",
            title: "Server Error",
            text: "Something went wrong. See tech support",
            showConfirmButton: true,
            customClass: {
              confirmButton: "btn btn-danger",
            },
            buttonsStyling: true,
          });
        });
    };

    return {
      seasons,
      units,
      inputs,
      locations,
      currencies,
      input,
      fetch,
      columns,
      perPage,
      currentPage,
      totalRecords,
      from,
      to,
      meta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      records,
      refetch,
      isBusy,
      // Methods
      required,
      saving,
      serverErrors,
      dataForm,
      myModal,
      changeSeason,
      invokeCreateForm,
      invokeUpdateForm,
      submit,
      isFormValid,
      handleCreate,
      handleUpdate,
      remove,
      resolveStatusVariant,
      formatPrice,
      changeUnit,
      selectedUnit,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
